import { useState } from "react";
import { idishCard } from "../../../../common/statics";
import { idishcard_info, idishcard_desc, close_popup } from "../../../../texts/fill";
import "./idishcard_info.css";
import { useSelector } from "react-redux";

const IdishcardInfo = () => {
  const user = useSelector(state => state.user);
  const [showPopup, setShowPopup] = useState(false);

  if (user.foodChain !== idishCard) return null;
  return (
    <>
      <div
        className="btn btn-primary"
        style={{
          width: '100px', height: '130px', margin: '0',
        }}
        onClick={() => setShowPopup(true)}
      >
        {idishcard_desc}
      </div>
      {showPopup && (
        <div
          className="modal d-flex align-items-center justify-content-center show"
          tabIndex="-1"
          style={{ background: 'rgba(0,0,0,0.3)' }}
          onClick={() => setShowPopup(false)}
        >
          <div className="card card-body info position-relative" style={{ maxWidth: '375px', borderRadius: '8px', padding: '9px', height: '900px' }} onClick={e => e.stopPropagation()}>
            <button
              type="button"
              className="btn-close position-absolute"
              style={{ top: 8, right: 8 }}
              onClick={() => setShowPopup(false)}
              aria-label={close_popup}
            />
            <br />
            <br />
            {idishcard_info}
          </div>
        </div>
      )}
    </>
  )
};

export default IdishcardInfo;
